<template>
  <div>
    <el-button @click="showCarousel" size="mini">查看截图</el-button>

    <el-dialog
      :close-on-click-modal="false"
      width="500px"
      :visible.sync="dialogEditorVisible"
      top="5vh"
    >
      <el-carousel :loop="false" height="500px" :autoplay="false" arrow="always">
        <el-carousel-item v-for="item in captureImageList" :key="item.Id">
          <span center>{{item.ImageInfor}}</span>
          <image-show
            center
            :src="item.Url"
            @click="onPriview(item.Url)"
            style="height:500px;width:500px"
            :isVisible="true"
          ></image-show>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
  </div>
</template>

<style>
.el-carousel__item:nth-child(2n) {
  background-color: white;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: white;
}
</style>

<script>
let _ = require("lodash");
import { getCaptureImageList } from "../../service/captureImage.service";
import imageShow from "@/components/fileHandler/imageShow";
export default {
  props: {
    studentId: Number,
    data: {
      CourseActivationId: Number,
    },
  },
  data() {
    return {
      captureImageList: [],
      dialogEditorVisible: false,
    };
  },
  components: {
    imageShow,
  },
  created() {},
  methods: {
    init() {},
    showCarousel() {
      getCaptureImageList(this.studentId, this.data.CourseActivationId)
        .then((result) => {
          if (result.success) {
            this.captureImageList = result.data;
            this.dialogEditorVisible = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onPriview(pictureUrl) {
      window.open(pictureUrl, "_blank");
    },
    onCloseEditor() {
      this.dialogEditorVisible = false;
    },
  },
  watch: {},
};
</script>



// WEBPACK FOOTER //
// src/components/common/captureImageReview.vue